<template>
  <div class="mine-bread">
    <!-- 面包屑 -->
    <shBread>
      <shBreadItem to="/">首页</shBreadItem>
      <shBreadItem><div class="bread">个人中心</div></shBreadItem>
    </shBread>
  </div>
  <div class="mine">
    <MineOverview :userData="userData" />
    <div class="list">
      <ShTabs v-model="activeName">
        <ShTabsPanel label="我的订单" name="buy"
          ><MineBuy :tableData="tableData" />
        </ShTabsPanel>
        <ShTabsPanel label="学习中心" name="class"
          ><MineStudy :showName="showName"
        /></ShTabsPanel>
        <ShTabsPanel label="会员中心" name="member"
          ><MineMember :userData="userData"
        /></ShTabsPanel>
      </ShTabs>
    </div>
  </div>
</template>

<script>
import MineOverview from "./components/mine-overview";
import MineBuy from "./components/mine-buy.vue";
import MineStudy from "./components/mine-study.vue";
import MineMember from "./components/mine-member.vue";
//import MineUnpaid from "./components/mine-unpaid.vue";

import { ref } from "vue";
import { OrderPaid } from "@/api/order";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { getInfoUpdate } from "@/api/user";
export default {
  components: { MineOverview, MineBuy, MineStudy, MineMember },
  setup() {
    const route = useRoute();
    const store = useStore();
    const tableData = ref([]);
    const activeName = ref("buy");
    const showName = ref("");
    const userData = ref([]);

    OrderPaid({ phone: store.state.user.profile.phone }).then((data) => {
      tableData.value = data.result.map((item) => {
        return {
          createAt: item.createAt,
          id: item._id,
          salePrice: item.salePrice,
          maID: item.maID,
          clID: item.clID,
          phone: item.phone,
          nickName: item.nickName,
          shclass: item.shclass,
          name: item.orderName,
          payed: item.payed,
          orderID: item.orderID,
          leID: item.leID,
          testsID: item.testsID,
          booksID: item.booksID,
          dateDifference: item.dateDifference,
        };
      });
    });

    getInfoUpdate({ id: store.state.user.profile._id }).then((data) => {
      showName.value = data[0].maID;
      userData.value = data;
    });
    return { activeName, tableData, showName, userData };
  },
};
</script>

<style lang="less" scoped>
.mine-bread {
  background: @shColor;
  .bread {
    width: 700px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.mine {
  width: 1240px;
  margin: 8px auto;
  .list {
    margin-top: 8px;
  }
}
</style>
